import { Component, computed, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { SiteCostType } from '@models/sites/site-cost.enum';

import {
  injectNgControl,
  NoopValueAccessorDirective,
} from '@shared/directives/noop-value-accessor.directive';
import { Option } from '@shared/types/components.type';

export type FilterCostOption = (options: Option[]) => Option[];

@Component({
  hostDirectives: [NoopValueAccessorDirective],
  imports: [NgSelectModule, ReactiveFormsModule],
  selector: 'aux-site-budget-cost-type-dropdown',
  template: `
    <div
      class="min-w-52"
      [class.flex]="horizontalLabel()"
      [class.space-x-2]="horizontalLabel()"
      [class.items-center]="horizontalLabel()"
      [class.min-w-72]="horizontalLabel()"
    >
      @if (label()) {
        <div [class.mb-1]="!horizontalLabel()" class="mb-1 text-xs">
          {{ label() }}
        </div>
      }
      <ng-select
        [formControl]="ngControl.control"
        placeholder="Select"
        [items]="costTypeOptionsToDisplay()"
        bindLabel="label"
        bindValue="value"
        [searchable]="true"
        [clearable]="false"
        [dropdownPosition]="'bottom'"
        class="flex-1"
      />
    </div>
  `,
})
export class SiteBudgetCostTypeDropdownComponent {
  ngControl = injectNgControl();

  filterCostOption = input<FilterCostOption>();

  costTypeOptions: Option[] = [
    {
      label: 'Patient Visits',
      value: SiteCostType.PATIENT_VISITS,
    },
    {
      label: 'Patient Invoiceables',
      value: SiteCostType.PATIENT_INVOICEABLES,
    },
    {
      label: 'Site Invoiceables',
      value: SiteCostType.SITE_INVOICEABLES,
    },
  ];

  costTypeOptionsToDisplay = computed(() => {
    const filterCostOption = this.filterCostOption();

    return filterCostOption ? filterCostOption(this.costTypeOptions) : this.costTypeOptions;
  });

  horizontalLabel = input(false);
  label = input('Cost Type');
}
